import { axiosInstance, baseUrl, handleErrors } from "./auth";

export const NOTIFICATION_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/socketNotification/list`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const NOTIFICATION_READ_SINGLE = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/socketNotification/readSingle`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const NOTIFICATION_READ_ALL = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/socketNotification/readAll`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

export const UNREADCOUNT = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/socketNotification/unreadCount`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};